import { RemoteCommand } from "./remote-command";
import { CommandResult } from "./command-result";
import { CommandTypes } from "./command-types";
import { DeleteCommand } from "./delete-command";

export class AddCommand<TTarget> implements RemoteCommand {
  commandResult: CommandResult | undefined;

  get commandType(): CommandTypes {
    return CommandTypes.add;
  }

  get target(): TTarget {
    return this._target;
  }

  isExecuted: boolean;

  constructor(
    private _target: TTarget,
    public commandId: number,
    public identifier: string
  ) {
    this.isExecuted = false;
  }

  undo(): DeleteCommand<TTarget> {
    if (!this.isExecuted) throw new Error('Command not yet executed. Cannot undo.');
    if (!this.commandResult?.isSuccessful) throw new Error('Command did not complete successfully. Cannot undo.')

    return new DeleteCommand(this._target, this.commandId, this.identifier);
  }

  createCommandDto(): any {
    return {
      commandId: this.commandId,
      identifier: this.identifier,
      target: this._target,
      commandType: this.commandType
    }
  }
}
